// extracted by mini-css-extract-plugin
export default {"gridWrapper":"MatchedSSNEINClients_gridWrapper__v7kEm"};